// extracted by mini-css-extract-plugin
export default {"title":"style_title__aLVLP","prodoctsList":"style_prodoctsList__gIyrH"};